import { render, staticRenderFns } from "./SacRadarChart.vue?vue&type=template&id=4ce2ba7e"
import script from "./SacRadarChart.vue?vue&type=script&lang=js"
export * from "./SacRadarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports